// Add this inside the InterviewProvider component to split video into 3-second chunks and upload them
// directly to Azure Function with proper naming convention and context integration

import { useRef, useEffect } from "react";
import { RecordRTCPromisesHandler } from "recordrtc";
// import axios from "axios";
import { uploadVideoChunk } from "../api/saveVideoBlob";

export const useVideoChunkUploader = (
  campaignLineId,
  campaignId,
  mediaStream
) => {
  const chunkIndexRef = useRef(0);
  const recorderRef = useRef(null);
  const intervalRef = useRef(null);

  // useEffect(() => {
  //   setTimeout(() => {
  //     stopChunkUploader();
  //   }, 100000);
  // }, []);

  const upload3SecondChunk = async (blob) => {
    const x = campaignLineId?.toString().padStart(6, "0");
    const y = campaignId?.toString().padStart(6, "0");
    const z = chunkIndexRef.current.toString().padStart(4, "0");
    const filename = `${x}_${y}_${z}.webm`;

    const file = new File([blob], filename, { type: "video/webm" });

    try {
      await uploadVideoChunk(file, filename);

      console.log(`✅ Uploaded: ${filename}`);
      chunkIndexRef.current++;
    } catch (error) {
      console.error(`❌ Upload failed for ${filename}`, error);
    }
  };

  function getAudioVideoConfigConstraints() {
    const videoConstraints: any = {};
    const audioConstraints: any = {};

    const audioVideoData: any =
      JSON?.parse(localStorage?.getItem("Video_Audio")) || "";

    if (audioVideoData.video === null || audioVideoData.video === undefined) {
      videoConstraints.facingMode = "user";
    } else {
      videoConstraints.deviceId = { exact: audioVideoData.video.deviceId };
    }

    if (audioVideoData.audio == null) {
      audioConstraints.deviceId = "environment";
    } else {
      audioConstraints.deviceId = { exact: audioVideoData.audio.deviceId };
    }

    return {
      video: videoConstraints,
      audio: audioConstraints,
    };
  }

  const startChunkUploader = async () => {
    let constraints1: any = getAudioVideoConfigConstraints();
    const streamL = await navigator.mediaDevices.getUserMedia(constraints1);

    if (!streamL) return;

    const recorder = new RecordRTCPromisesHandler(streamL, {
      type: "video",
      mimeType: "video/webm",
      videoBitsPerSecond: 500000,
      frameRate: 15,
    });

    await recorder.startRecording();
    recorderRef.current = recorder;

    intervalRef.current = setInterval(async () => {
      try {
        await recorder.stopRecording();
        const blob = await recorder.getBlob();
        await upload3SecondChunk(blob);
        await recorder.startRecording();
      } catch (error) {
        console.error("Chunk processing failed:", error);
      }
    }, 5000);
  };

  // const stopChunkUploader = async () => {
  //   if (intervalRef.current) {
  //     clearInterval(intervalRef.current);
  //   }
  //   if (recorderRef.current) {
  //     await recorderRef.current.stopRecording();
  //     recorderRef.current = null;
  //   }
  // };

  const stopChunkUploader = async () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (recorderRef.current) {
      try {
        await recorderRef.current.stopRecording();
        const blob = await recorderRef.current.getBlob();

        if (blob && blob.size > 0) {
          await upload3SecondChunk(blob);
        }

        recorderRef.current = null;
      } catch (error) {
        console.error(
          "❌ Error while stopping and uploading last chunk:",
          error
        );
      }
    }
  };

  return { startChunkUploader, stopChunkUploader };
};
